import React, { useState } from 'react';
import GetAppIcon from '@material-ui/icons/GetApp';
import PublishIcon from '@material-ui/icons/Publish';
import {
  CircularProgress,
  Fab,
  Hidden,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  withStyles,
  useTheme,
  useMediaQuery,
  Tooltip,
  Paper,
  InputBase,
  InputAdornment,
  Button,
  Grid
} from '@material-ui/core';
import { Add, Create, Delete, FileCopy, Visibility, Share } from '@material-ui/icons';
import SearchIcon from '@material-ui/icons/Search';
import styles from './styles';
import { Link } from 'react-router-dom';
import Loading from '../Loading';
import { SuccessToast } from '../Toast';
import SectionHeader from '../SectionHeader';
import { PrimaryButton } from '../Button';
import Surface from '../Surface';
import ReactJson from 'react-json-view';

export const ROWS_PER_PAGE = 10;

const TableComponent = ({
  classes,
  data,
  page,
  dataCount,
  loading,
  updating,
  path,
  newMessage,
  createEnabled,
  columns,
  handleOpenForm,
  handleDelete,
  handleChangePage,
  successMessage,
  onCloseToast,
  loadingMore,
  title,
  enableSearch,
  enableFilter,
  enableImportExport,
  onImport,
  onExport,
  searchWord,
  handleSearchChange,
  handleFilterChange,
  enableDuplicate,
  enableEdit,
  enableActions,
  enableShare,
  handleCopyCurl
}) => {
  const theme = useTheme();
  const [rowIdOver, setRowIdOver] = useState('');
  const emptyRows = ROWS_PER_PAGE - Math.min(ROWS_PER_PAGE, data.length - page * ROWS_PER_PAGE);
  const handleOver = rowId => setRowIdOver(rowId);
  const handleLeave = () => setRowIdOver('');
  const smallScreen = useMediaQuery(theme.breakpoints.down(1020));

  const renderTableHeader = () =>
    columns.map(column => {
      const Cell = () => (
        <TableCell
          style={{ color: '#353535de', minWidth: column.minWidth }}
          classes={{ root: classes.tableHead }}
        >
          {column.label}
        </TableCell>
      );

      if (column.hidden) {
        return (
          <Hidden key={column.id} {...column.hidden}>
            <Cell />
          </Hidden>
        );
      } else {
        return <Cell key={column.id} />;
      }
    });

  const renderTableRow = row =>
    columns.map(column => {
      const cellProps = {
        // onClick: () => handleOpenForm(row._id),
        key: column.id,
        classes: { root: classes.tableCell },
      };
      if ( title !== 'Logs de auditoría') cellProps.onClick = () => handleOpenForm(row._id);
      
      if (column.hidden) {
        return (
          <Hidden key={column.id} {...column.hidden}>
            <TableCell {...cellProps}>
              {column.field && row[column.id] ? row[column.id][column.field] : row[column.id]}
            </TableCell>
          </Hidden>
        );
      } else {
        if (column.field === 'isServiceUser' && row[column.id]) {
          return (
            <TableCell {...cellProps}>
              Servicio
            </TableCell>
          );
        } else if (column.field === 'user') {
          return (
            <TableCell {...cellProps}>
              {row[column.id] ? row[column.id].firstName + ' ' + row[column.id].lastName : ''}
            </TableCell>
          );
        } else if (column.field === 'affectedEntity') {
          return (
            <TableCell {...cellProps}>
              { row[column.id] ? <ReactJson src={row[column.id]}  name={'Detalle'} collapsed={true} collapseStringsAfterLength={50} displayDataTypes={false} /> : '' }
            </TableCell>
          )
        }
        return (
          <TableCell {...cellProps}>
            {column.field && row[column.id] ? row[column.id][column.field] : row[column.id]}
          </TableCell>
        );
      }
    });

  const renderActions = row => (
    <div className={classes.iconsContainer}>
      <Tooltip title="Ver información">
        <Link to={`${path}/${row._id}`}>
          <IconButton>
            <Visibility />
          </IconButton>
        </Link>
      </Tooltip>
      { !enableShare ? null : 
        <Tooltip title="Copiar cUrl">
          <IconButton onClick={() => handleCopyCurl(row)}>
            <Share/>
          </IconButton>
        </Tooltip>
      }
      { !enableEdit ? null : 
        <>
          <Tooltip title="Editar">
            <Link
              to={{
                pathname: `${path}/${row._id}`,
                editMode: true,
              }}
            >
              <IconButton>
                <Create />
              </IconButton>
            </Link>
          </Tooltip>
          <Tooltip title="Eliminar">
            <IconButton onClick={() => handleDelete(row._id)}>
              <Delete />
            </IconButton>
          </Tooltip>
        </>
      }
      { !enableDuplicate ? null : 
        <Tooltip title="Duplicar">
          <Link
            to={{
              pathname: `${path}/new`,
              duplicate: row._id,
            }}
          >
            <IconButton>
              <FileCopy/>
            </IconButton>
          </Link>
        </Tooltip>
      }
      { !enableImportExport ? null :
        <Tooltip title="Exportar">
          <IconButton onClick={() => onExport(data, row._id, row.description)}>
            <GetAppIcon/>
          </IconButton>
        </Tooltip>
      }
    </div>
  );

  return (
    <div>
      <SectionHeader title={title}>
        <span style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-end' }}>
          <Grid container spacing={1}>
            {!smallScreen && createEnabled ? (
              <Grid item xs={12} style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-end' }}>
                <PrimaryButton onClick={() => handleOpenForm()} startIcon={<Add />}>
                  {newMessage}
                </PrimaryButton>
              </Grid>
            ) : null}
            {smallScreen && createEnabled ? (
              <Grid item xs={12} style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-end' }}>
                <Fab size="small" color="primary" aria-label="add" onClick={() => handleOpenForm()}>
                  <Add style={{ color: 'white' }} />
                </Fab>
              </Grid>
            ) : null}
          { !enableImportExport ? null : (
            smallScreen ? (
              <>
                <Grid item xs={12} style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-end' }}>
                  <Fab size="small" color="primary" aria-label="export" onClick={() => onExport(data)}>
                    <GetAppIcon style={{
                      backgroundColor: 'primary',
                      color: 'white',
                    }} />
                  </Fab>
                </Grid>
                <Grid item xs={12} style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-end' }}>
                  <Fab size="small" color="primary" aria-label="import" onClick={() => onImport()}>
                    <PublishIcon style={{
                      backgroundColor: 'primary',
                      color: 'white',
                    }} />
                  </Fab>
                </Grid>
              </>
            ) : (
              <>
                <Grid item xs={12} style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-end' }}>
                    <PrimaryButton
                      onClick={() => onExport(data)}
                      startIcon={<GetAppIcon />}
                    >
                      { searchWord !== '' ? 'Exportar selección' : 'Exportar listado'}
                    </PrimaryButton>
                </Grid>
                <Grid item xs={12} style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-end' }}>
                  <PrimaryButton
                    onClick={() => onImport()}
                    startIcon={<PublishIcon />}
                  >
                    {'Importar listado'}
                  </PrimaryButton>
                </Grid>
              </>
            )
          )}
          </Grid>
        </span>
      </SectionHeader>
      {!enableSearch ? null : (
        <Paper
          variant="outlined"
          style={{ minWidth: '40rem', borderRadius: '3rem' }}
          className={classes.root}
        >
          <InputBase
            style={{ width: '100%', marginLeft: '1.5rem' }}
            placeholder="Ingrese su consulta"
            value={searchWord}
            onChange={handleSearchChange}
            startAdornment={
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            }
          />
        </Paper>
      )}
      {!enableFilter ? null : (
        <Paper
          variant="outlined"
          style={{ minWidth: '40rem'}}
          className={classes.root}
        >
          <Button onClick={() => handleFilterChange(true)} value='filter'>Solo usuarios de servicio</Button>
          <Button onClick={() => handleFilterChange(false)} value='all'>Mostrar todos</Button>
        </Paper>
      )}
      <Surface className={classes.root}>
        {loading ? (
          <Loading style={{ height: 639 }} />
        ) : (
          <div>
            <TableContainer style={{ borderRadius: 4 }}>
              <Table stickyHeader aria-label="sticky table">
                <TableHead>
                  <TableRow>
                    {renderTableHeader()}
                    <TableCell classes={{ root: classes.tableHead }} style={{ minWidth: 200 }}>
                      {updating && <CircularProgress size={24} style={{ marginRight: 20 }} />}
                    </TableCell>
                  </TableRow>
                </TableHead>
                {loadingMore ? (
                  <caption style={{ padding: 0, color: 'black', height: 520 }}>
                    <Loading style={{ height: 520 }} />
                  </caption>
                ) : (
                  <TableBody>
                    {data
                      .slice(page * ROWS_PER_PAGE, page * ROWS_PER_PAGE + ROWS_PER_PAGE)
                      .map(row => {
                        const showActions = rowIdOver === row._id || smallScreen;
                        return (
                          <TableRow
                            hover
                            tabIndex={-1}
                            key={row._id}
                            onMouseLeave={() => handleLeave()}
                            onMouseOver={() => handleOver(row._id)}
                          >
                            {renderTableRow(row)}
                            <TableCell
                              style={{ paddingTop: 2, paddingBottom: 2 }}
                              classes={{ root: classes.tableCell }}
                            >
                              {showActions && enableActions ? (
                                renderActions(row)
                              ) : (
                                <div style={{ height: '100%', width: '100%' }} />
                              )}
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    {emptyRows > 0 && (
                      <TableRow style={{ height: 52 * emptyRows }}>
                        <TableCell colSpan={6} classes={{ root: classes.tableCell }} />
                      </TableRow>
                    )}
                  </TableBody>
                )}
              </Table>
            </TableContainer>
            <TablePagination
              rowsPerPageOptions={[ROWS_PER_PAGE]}
              component="div"
              count={dataCount}
              rowsPerPage={ROWS_PER_PAGE}
              page={page}
              labelDisplayedRows={({ from, to, count }) => from + ' al ' + to + ' de ' + count}
              onChangePage={handleChangePage}
              classes={{ root: classes.pagination }}
            />
          </div>
        )}
      </Surface>
      <SuccessToast open={successMessage !== ''} onClose={onCloseToast} text={successMessage} />
    </div>
  );
};

export default withStyles(styles)(TableComponent);
